import clsx from 'clsx'
import { usePaymentLimit } from 'modules/bank/hooks/card/usePaymentLimit'
import { LimitParametersRule } from 'modules/bank/types'
import { Amount } from 'modules/common/components/Amount/Amount'
import { CircleProgressBar } from 'modules/common/components/_ui/CircleProgressBar/CircleProgressBar'
import { useTranslation } from 'modules/common/hooks/useTranslation'

interface Props {
  limit: LimitParametersRule
  frequency: 'daily' | 'monthly'
  className?: string
}

export const BankingLimit: React.FC<Props> = ({
  limit,
  frequency,
  className,
}) => {
  const {
    values: { currentValue, maxValue, progressPercentage },
    theme: { circleBgColor, progressColor },
  } = usePaymentLimit({
    limit,
  })
  const { t } = useTranslation('bank-components')

  return (
    <div
      className={clsx('flex content-center items-center space-x-4', className)}
    >
      <CircleProgressBar
        progressColor={progressColor}
        circleBgColor={circleBgColor}
        size="48"
        strokeWidth="42"
        progressPercentage={progressPercentage}
        className="shrink-0"
      />
      <div className="space-y-2 font-bold">
        <p className="text-info-400">
          {t('bankingLimit.title', { context: frequency })}
        </p>
        <div className="flex">
          <Amount amount={currentValue} className={progressColor} />
          <p className="font-headings">&nbsp;/&nbsp;</p>
          <Amount amount={maxValue} />
        </div>
      </div>
    </div>
  )
}
